

































































































































































































































































































































































































































































































































































































































































































































































































































































import BaseComponent from '@/core/base.component';
import Component from 'vue-class-component';
import {
  BrandDto,
  BrandKioskMapperDto,
  BrandUpdateDto,
  FoodCategoryDto,
  MenuDto,
  MenuListDto,
  DeliverySpaceDto,
} from '@/dto';
import BrandService from '../../../services/brand.service';
import PaymentListService from '../../../services/payment-list.service';
import MenuService from '../../../services/menu.service';
import FoodCategoryService from '../../../services/food-category.service';
import CodeManagementService from '../../../services/code-management.service';
import { FileAttachmentDto } from '@/services/shared/file-upload';
import FileUploadService from '../../../services/shared/file-upload/file-upload.service';
import { UPLOAD_TYPE } from '../../../services/shared/file-upload/file-upload.service';
import { ATTACHMENT_REASON_TYPE } from '@/services/shared/file-upload';
import toast from '../../../../resources/assets/js/services/toast.js';
import { CONST_YN, YN, Pagination } from '@/common';
import MenuCreate from '../../menu/components/MenuCreate.vue';
import MenuUpdate from '../../menu/components/MenuUpdate.vue';
import { CONST_SPACE_TYPE, SPACE, SPACE_TYPE } from '@/services/shared';
import { CodeManagementDto } from '@/services/init/dto';
import BrandKioskMapperService from '../../../services/brand-kiosk-mapper.service';
import brandService from '../../../services/brand.service';
import { Watch } from 'vue-property-decorator';
import {
  addHashToLocation,
  ReverseQueryParamMapper,
  RouterQueryParamMapper,
} from '@/core/utils';
// import BrandRevenusGraph from './BrandRevenusGraph.vue';

@Component({
  name: 'BrandDetail',
  components: {
    MenuCreate,
    MenuUpdate,
    // BrandRevenusGraph,
  },
})
export default class BrandDetail extends BaseComponent {
  constructor() {
    super();
  }
  private brandDto = new BrandDto();
  private brandUpdateDto = new BrandUpdateDto();
  private foodCategorySelect: FoodCategoryDto[] = [];
  private newBrandLogo: FileAttachmentDto[] = [];
  private logoChanged = false;
  private newMainMenu: FileAttachmentDto[] = [];
  private newMainBanner: FileAttachmentDto[] = [];
  private newSideBanner: FileAttachmentDto[] = [];
  private newMobileSideBanner: FileAttachmentDto[] = [];
  private menuChanged = false;
  private mainBannerChanged = false;
  private sideBannerChanged = false;
  private mobileSideBannerChanged = false;
  private showYn: YN[] = [...CONST_YN];
  private spaceType = [2, 1];
  private menus: MenuDto[] = [];
  private menuListDto = new MenuListDto();
  private menuTotalCount = null;
  private pagination = new Pagination();
  private typePagination = new Pagination();
  private dataLoading = false;
  private storeCountValues: CodeManagementDto[] = [];
  private costValues: CodeManagementDto[] = [];
  private difficultyValues: CodeManagementDto[] = [];
  private brandRevenueInfo = new BrandKioskMapperDto();
  private revenues: BrandKioskMapperDto[] = [];
  private totalRevenue = null;
  private deliverySpaces: DeliverySpaceDto[] = [];
  private deliverySpacesTotalCount = null;

  // @Watch('typePagination', { deep: true })
  // typePaginationChanged() {
  //   this.findRelatedSpaceTypes(this.$route.params.id, this.typePagination);
  // }

  // find for detail
  findOne(id) {
    BrandService.findOne(id).subscribe(res => {
      if (res) {
        this.brandDto = res.data;
        this.newBrandLogo = [];
        this.logoChanged = false;
        this.newMainMenu = [];
        this.menuChanged = false;
        this.newMainBanner = [];
        this.mainBannerChanged = false;
        this.newSideBanner = [];
        this.sideBannerChanged = false;
        this.newMobileSideBanner = [];
        this.mobileSideBannerChanged = false;
      }
      this.brandRevenueInfo.brandNo = id;
      BrandKioskMapperService.getRevenueForBrand(
        this.brandRevenueInfo,
      ).subscribe(res => {
        this.revenues = res.data;
        function amount(item) {
          return item.sum;
        }
        function sum(prev, next) {
          return prev + next;
        }
        if (this.revenues && this.revenues.length > 0) {
          this.totalRevenue = this.revenues.map(amount).reduce(sum);
        }
      });
    });
  }

  findRelatedSpaceTypes() {
    addHashToLocation(this.typePagination);
    brandService
      .findRelatedSpaceTypes(this.$route.params.id, this.typePagination)
      .subscribe(res => {
        if (res) {
          this.deliverySpaces = res.data.items;
          this.deliverySpacesTotalCount = res.data.totalCount;
        }
      });
  }

  // show update modal
  showUpdateModal() {
    this.getFoodCategories();
    this.brandUpdateDto = this.brandDto;
    this.findOne(this.$route.params.id);
  }

  showMenuUpdateModal(menuNo) {
    this.$root.$emit('menu_update', menuNo);
    this.$bvModal.show('update_menu');
  }

  // update brand
  updateBrand() {
    if (this.newBrandLogo.length > 0) {
      this.brandUpdateDto.logo = this.newBrandLogo;
    } else {
      delete this.brandUpdateDto.logo;
    }

    if (this.newMainMenu.length > 0) {
      this.brandUpdateDto.mainMenuImage = this.newMainMenu;
    } else {
      delete this.brandUpdateDto.mainMenuImage;
    }

    if (this.newMainBanner.length > 0) {
      this.brandUpdateDto.mainBanner = this.newMainBanner;
    } else {
      delete this.brandUpdateDto.mainBanner;
    }

    if (this.newSideBanner.length > 0) {
      this.brandUpdateDto.sideBanner = this.newSideBanner;
    } else {
      delete this.brandUpdateDto.sideBanner;
    }

    if (this.newMobileSideBanner.length > 0) {
      this.brandUpdateDto.mobileSideBanner = this.newMobileSideBanner;
    } else {
      delete this.brandUpdateDto.mobileSideBanner;
    }
    BrandService.update(this.$route.params.id, this.brandUpdateDto).subscribe(
      res => {
        if (res) {
          toast.success('수정완료');
          this.findOne(this.$route.params.id);
        }
      },
    );
  }

  searchMenus(isPagination?: boolean) {
    this.dataLoading = true;
    if (!isPagination) {
      this.pagination.page = 1;
    }
    this.menuListDto.brandNo = this.$route.params.id;
    this.pagination.limit = 5;
    MenuService.findAll(this.menuListDto, this.pagination).subscribe(res => {
      this.dataLoading = false;
      this.menus = res.data.items;
      this.menuTotalCount = res.data.totalCount;
    });
  }

  paginateSearch() {
    this.searchMenus(true);
  }

  // get food category
  getFoodCategories() {
    FoodCategoryService.findForSelect().subscribe(res => {
      this.foodCategorySelect = res.data;
    });
  }

  // upload brand logo
  async upload(file: File) {
    if (file) {
      const attachments = await FileUploadService.upload(
        UPLOAD_TYPE.BRAND_LOGO,
        [file],
      );
      this.newBrandLogo = [];
      this.newBrandLogo.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
      this.logoChanged = true;
    }
  }

  // remove brand logo
  removeBrandLogo() {
    this.newBrandLogo = [];
    this.$refs['fileInput'].reset();
    this.logoChanged = false;
  }

  // upload main menu
  async uploadMainmenu(file: File) {
    if (file) {
      const attachments = await FileUploadService.upload(
        UPLOAD_TYPE.MAIN_MENU_IMAGE,
        [file],
      );
      this.newMainMenu = [];
      this.newMainMenu.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
      this.menuChanged = true;
    }
  }

  // remove main menu
  removeMainMenu() {
    this.newMainMenu = [];
    this.$refs['fileInputMainMenu'].reset();
    this.menuChanged = false;
  }

  // upload brand main banner
  async uploadMainBanner(file: File) {
    if (file) {
      const attachments = await FileUploadService.upload(
        UPLOAD_TYPE.BRAND_BANNER,
        [file],
      );
      this.newMainBanner = [];
      this.newMainBanner.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
      this.mainBannerChanged = true;
    }
  }

  // remove main banner
  removeMainBanner() {
    this.newMainBanner = [];
    this.$refs['fileInputMainBanner'].reset();
    this.mainBannerChanged = false;
  }

  // upload brand side banner
  async uploadSideBanner(file: File) {
    if (file) {
      const attachments = await FileUploadService.upload(
        UPLOAD_TYPE.BRAND_BANNER,
        [file],
      );
      this.newSideBanner = [];
      this.newSideBanner.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
      this.sideBannerChanged = true;
    }
  }

  // remove side banner
  removeSideBanner() {
    this.newSideBanner = [];
    this.$refs['fileInputSideBanner'].reset();
    this.sideBannerChanged = false;
  }

  // upload mobile side banner
  async uploadMobileSideBanner(file: File) {
    if (file) {
      const attachments = await FileUploadService.upload(
        UPLOAD_TYPE.BRAND_BANNER,
        [file],
      );
      this.newMobileSideBanner = [];
      this.newMobileSideBanner.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
      this.mobileSideBannerChanged = true;
    }
  }

  // remove mobile side banner
  removeMobileSideBanner() {
    this.newMobileSideBanner = [];
    this.$refs['fileInputMobileSideBanner'].reset();
    this.mobileSideBannerChanged = false;
  }

  deleteOne() {
    BrandService.deleteOne(this.$route.params.id).subscribe(res => {
      if (res) {
        toast.success('삭제완료');
        this.$router.push('/brand');
      }
    });
  }
  deleteBrandFromEveryDistrict() {
    BrandService.deleteBrandEveryDistrict(this.$route.params.id).subscribe(
      res => {
        if (res) {
          toast.success('삭제완료');
          this.$bvModal.hide('delete_every_district');
          this.findRelatedSpaceTypes();
        }
      },
    );
  }
  addBrandToEveryDistrict() {
    BrandService.addBrandEveryDistrict(this.$route.params.id).subscribe(res => {
      if (res) {
        toast.success('추가완료');
        this.findRelatedSpaceTypes();
      }
    });
  }

  created() {
    const query = ReverseQueryParamMapper(location.search);
    if (query) {
      this.typePagination.limit = +query.limit;
      this.typePagination.page = +query.page;
    } else {
      this.typePagination.page = 1;
      this.typePagination.limit = 6;
    }
    this.findRelatedSpaceTypes();

    const id = this.$route.params.id;
    this.pagination.page = 1;

    this.getCommonCodes('costValues', 'BRAND');
    this.getCommonCodes('storeCountValues', 'STORE_COUNT');
    this.getCommonCodes('difficultyValues', 'DIFFICULTY');
    this.searchMenus();
    this.findOne(id);
  }

  mounted() {
    this.$root.$on('menu_create', () => {
      this.searchMenus();
    });
  }
}
